import { colord } from "colord";

/** Server-render fallbacks — `getComputedStyle` is unavailable before hydration. */
export const CSS_VAR_FALLBACK: Record<string, string> = {
  "--primary": "#FF5101",
  "--chart-1": "#0ea5e9",
  "--chart-2": "#a855f7",
  "--chart-3": "#f59e0b",
  "--chart-4": "#10b981",
  "--chart-5": "#ef4444",
  "--chart-6": "#6366f1",
};

/** Resolves `var(--token, fallback)` to a concrete color string. */
export function resolveCssColor(bg: string): string {
  if (!bg || !bg.startsWith("var(")) {
    return bg;
  }
  const inner = bg.slice(4, -1);
  const [rawName, rawFallback] = inner.split(",");
  const varName = rawName?.trim();
  if (!varName) {
    return bg;
  }
  if (typeof window !== "undefined") {
    try {
      const value = getComputedStyle(document.documentElement)
        .getPropertyValue(varName)
        .trim();
      if (value) {
        return value;
      }
    } catch {}
  }
  const tokenFallback = CSS_VAR_FALLBACK[varName];
  if (tokenFallback) {
    return tokenFallback;
  }
  const fallback = rawFallback?.trim();
  if (fallback) {
    return resolveCssColor(fallback);
  }
  return bg;
}

/** White on dark backgrounds, near-black on light ones. `undefined` when unparseable. */
export function autoContrastColor(bg: string | undefined): string | undefined {
  if (!bg) {
    return undefined;
  }
  try {
    const parsed = colord(resolveCssColor(bg));
    if (!parsed.isValid()) {
      return undefined;
    }
    return parsed.brightness() < 0.65 ? "#ffffff" : "#171717";
  } catch {
    return undefined;
  }
}
